import { render, staticRenderFns } from "./rolePermissionList.vue?vue&type=template&id=070b6154&scoped=true&"
import script from "./rolePermissionList.vue?vue&type=script&lang=js&"
export * from "./rolePermissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070b6154",
  null
  
)

export default component.exports